import React, {Component} from "react";
import {Layout,Table, Divider, Modal, Form, Input, Pagination , Button, message} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './illCase.less'
import '../../assets/css/admin.less'
import {reqAddIllCase, reqCaseDetail, reqDeleteIllCase, reqEditIllCase, reqIllCaseList} from "../../api";
import {withRouter} from "react-router";

const {Content} = Layout;
const {TextArea} = Input;

/**
 * 病例考核路由组件
 */
class IllCase extends Component {

    state = {
        total:0,
        page:1,
        illCaseList:[],
        selectValue:'',
        ModalText:'',
        visible:false,
        ill:{},
        deleteVisible:false,
        deleteId:'',
        deleteName:'',
        selectedRowKeys: [],
        size:10
    };

    getIllCaseList = async (data) =>{
        const result = await reqIllCaseList(data);
        if(result.code === '000000') {
            this.setState({
                illCaseList:result.data.rows,
                total:result.data.total,
                page:result.data.page
            })
        }else {
            message.error(result.msg);
        }
    };

    pageClick = async(page) => {
        this.getIllCaseList({
            page:page,
            size:10
        });
    };

    showEditModal = async(record) => {
        const result = await reqCaseDetail(record.id);
        this.setState({
            visible: true,
            ModalText:'修改病例',
            ill:result.data
        });
    };

    showDeleteModal =(record,type)=> {
        if(type==='删除') {
            this.setState({
                deleteId:record.id,
                deleteName:record.title,
                deleteVisible:true
            })
        }else {
            if(this.state.deleteId===''){
                message.info("没有选中行");
            }else {
                this.setState({
                    deleteVisible:true
                })
            }
        }
    };

    deleteIllCase = async(ids) => {
        const result = await reqDeleteIllCase(ids);
        if(result.code==='000000'){
            message.success("作废成功");
            this.getIllCaseList({
                page:1,
                size:10
            });
            this.handleCancel();
        }
    };

    illQuestion = (record)=> {
        sessionStorage.setItem("caseTo","/illQuestion");
        sessionStorage.setItem("illId",record.id);
        this.props.history.push("/illQuestion");
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText:'新增病例',
            ill:{},
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible:false,
            deleteId:'',
            deleteName:'',
            selectedRowKeys:[]
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields (async (err, values) => {
            if (!err) {
                let result={};
                if(this.state.ModalText==='新增病例'){
                    const data = {
                        title:values.title,
                        description:values.description
                    };
                    result = await reqAddIllCase(data);
                }else {
                    result = await reqEditIllCase(values);
                }
                if(result.code === '000000') {
                    message.success(this.state.ModalText+"成功");
                    this.setState({
                        visible:false
                    });
                    this.getIllCaseList({
                        size:10,
                        page:1
                    })
                }
            }
        });
    };

    itemRender =(current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total)=>{
        return '共'+total+'条记录/每页'+this.state.size+'条';
    };

    componentDidMount = async() => {
        this.getIllCaseList({
            page:1,
            size:10
        });
        document.getElementsByClassName("ant-menu-item")[3].click();
        sessionStorage.clear();
        sessionStorage.setItem("caseTo","illCase");
        document.getElementsByClassName("ant-menu-item")[4].style.setProperty("display", "block");
        document.getElementsByClassName("ant-menu-item")[5].style.setProperty("color", "#12c4ed");
        document.getElementsByClassName("ant-menu-item")[5].style.setProperty("display", "block");
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render (){

        const {getFieldDecorator} = this.props.form;

        const { total,page,illCaseList,ModalText,visible,ill,deleteVisible,deleteId,deleteName,selectedRowKeys} = this.state;

        const columns = [
        {
            title: '编号',
            dataIndex: 'id',
            key: 'id',
            render: (text, record,index) => (
                <span>{(this.state.page-1)*this.state.size+index+1}</span>
            ),
        },
        {
            title: '案例标题',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
                <span>
                    <a onClick={this.illQuestion.bind(this,record)}>题库管理</a>
                    <Divider type="vertical" />
                    <a style={{color:'#12c4ed'}} onClick={this.showEditModal.bind(this,record)}>编辑</a>
                    <Divider type="vertical" />
                    <a onClick={this.showDeleteModal.bind(this,record,'删除')}>作废</a>
                </span>
            ),
        },
    ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].title)
                }
                this.setState({
                    deleteId:selectedRowKeys.toString(),
                    deleteName:name.toString(),
                    selectedRowKeys:selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right'>
                            <div className='table_search'>
                                <Button className='batch_delete' onClick={this.showDeleteModal.bind(this,deleteId,'批量删除')}>批量作废</Button>
                                <Button className='add_class' onClick={this.showAddModal}>新增病例</Button>
                                <label className='box_label'>建议：每个病例上传不少于10道题</label>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                   dataSource={illCaseList} rowKey={illCaseList => illCaseList.id}/>
                            <Pagination total={total} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal className='illCase_modal' title={ModalText} visible={visible} onCancel={this.handleCancel}
                               footer={null} destroyOnClose='true'>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue:ill.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item>
                                    {getFieldDecorator('title', {
                                        rules: [{ required: true, message: '请输入病例名称!' }],
                                        initialValue:ill.title
                                    })(
                                        <Input className='input' placeholder='病例名称'/>,
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    {getFieldDecorator('description', {
                                        rules: [{ required: true, message: '请输入病例描述!' }],
                                        initialValue:ill.description
                                    })(
                                        <TextArea rows={4} placeholder='病例描述'/>,
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        确定
                                    </Button>
                                    <Button onClick={this.handleCancel}>
                                        取消
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteIllCase.bind(this,deleteId)}
                            onCancel={this.handleCancel}>
                            <div>确定作废吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapIllCase = Form.create()(IllCase);
export default WrapIllCase;
withRouter(IllCase);